var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.1667 10.9375 L4.1667 5.4999 C4.1667 3.8431 5.5098 2.4999 7.1667 2.4999 L12.6042 2.5 M9.1667 17.5 L14.7917 17.5 C15.8272 17.5 16.6667 16.6605 16.6667 15.625 L16.6667 7.5 C16.6667 6.4645 15.8272 5.625 14.7917 5.625 L9.1667 5.625 C8.1311 5.625 7.2917 6.4645 7.2917 7.5 L7.2917 15.625 C7.2917 16.6605 8.1311 17.5 9.1667 17.5 Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.f1aba9be64e4814c7161068be37e7897.svg";
export { ForwardRef as ReactComponent };